import parser from 'html-react-parser';

const ContentDisplay = (props: { htmlContent: string }): JSX.Element => {
  const { htmlContent } = props;

  return <>{parser(htmlContent)}</>;
};
export default ContentDisplay;
